<template>
  <div class="banner-cards" :class="type ? type : ''">
    <router-link
      :to="getHref(banners[type == 'mini' ? 4 : 0], defaultBanners[type == 'mini' ? 3 : 0]?.url)"
      class="banner-card "
      @click="bannerClick(banners[type == 'mini' ? 4 : 0])"
      :style="getBannerImage(banners[type == 'mini' ? 4 : 0], defaultBanners[type == 'mini' ? 3 : 0]?.image_url)"
    >
      <div class="absolute inset-0" v-if="isVideoUrl(banners[type == 'mini' ? 4 : 0])">
        <HLSPlayer
          :isVisible="true"
          :videoSrc="getVideoUrl(banners[type == 'mini' ? 4 : 0])"
        />
      </div>
    </router-link>
    <router-link
      :to="getHref(banners[type == 'mini' ? 5 : 1], defaultBanners[type == 'mini' ? 4 : 1]?.url)"
      class="banner-card "
      @click="bannerClick(banners[type == 'mini' ? 5 : 1])"
      :style="getBannerImage(banners[type == 'mini' ? 5 : 1], defaultBanners[type == 'mini' ? 4 : 1]?.image_url)"
    >
      <div class="absolute inset-0" v-if="isVideoUrl(banners[type == 'mini' ? 5 : 1])">
        <HLSPlayer
          :isVisible="true"
          :videoSrc="getVideoUrl(banners[type == 'mini' ? 5 : 1])"
        />
      </div>
    </router-link>
  </div>
</template>

<script>
import HLSPlayer from "@/components/HLSPlayer.vue";
import Segments from "@/modules/Segments";

const { BannerVisit } = Segments();
export default {
  name: "BannerCards",
  components: { HLSPlayer },
  props: {
    banners: {
      type: Object,
      default: () => {}
    },
    defaultBanners: Array,
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showVideo: false,
      showVideo1: false,
    };
  },
  methods: {
    getUrl(url) {
      return url.replace("https://medusadistribution.com/", "/");
    },
    getVideoUrl(banner) {
      return banner?.winners?.length
          ? banner?.winners[0]?.asset[0]?.url
          : null;
    },
    isVideoUrl(banner) {
      const url = this.getVideoUrl(banner);
      if(url === null) return false;
      const videoExtensions = ['.mp4', '.mov', '.m3u8', '.avi', '.wmv', '.flv', '.webm'];
      const urlLower = url.toLowerCase();
      return videoExtensions.some(ext => urlLower.endsWith(ext));
    },
    bannerClick(banner){
      BannerVisit(banner);
    },
    getHref(banner, temp) {
      // Ensure winners is an array
      const winners = Array.isArray(banner?.winners) ? banner.winners : [];
      if (winners.length === 0) {
        return (temp ? temp : '/');
      }

      // Get the first winner
      const winner = winners[0];
      const href = winner?.type === 'product'
        ? `/products/${winner?.id}`
        : typeof winner?.id === 'string'
          ? winner?.id?.replace("https://medusadistribution.com/", "/")
          : (temp ? temp : '/');

      return href;
    },
    getBannerImage(banner, temp) {
        return banner?.winners?.length
          ? `background-image: url('${
            banner?.winners[0]?.asset[0]?.url
            }')`
          : `background-image: url('${temp}')`;
      }
    }
};
</script>

<style lang="scss" scoped>
.banner-cards {
  @apply grid grid-cols-1 lg:grid-cols-2 gap-5;

  .banner-card {
    @apply flex flex-col items-start justify-end p-5 md:p-10 relative rounded-lg text-white bg-no-repeat  bg-white bg-cover bg-center overflow-hidden max-w-full;

    aspect-ratio: 556/285;

    .banner-card-inner {
      @apply relative z-10 space-y-8;
    }
  }

  &.mini {
    .banner-card {
      aspect-ratio: 556/105;
    }
  }

  h3 {
    @apply text-lg md:text-2xl font-semibold mb-3;
  }

  p {
    @apply text-base md:text-xl font-medium text-opacity-60 text-white max-w-xs;
  }

  button {
    @apply inline-block text-sm font-medium bg-white text-black px-6 py-1.5 rounded shadow;
  }

  .play-icon {
    @apply inline-flex justify-center items-center bg-white w-12 h-12 rounded-full text-black focus:outline-none absolute right-8 bottom-8;

    svg {
      @apply w-6 h-6;
    }
  }
}
</style>
